import ContactForm from "@/features/contact-company-page/components/contact-form/ContactForm";

const ContactPage = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default ContactPage;
